import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 * Cell renderer for BOL numbers column
 * Shows linked BOL numbers with ability to navigate to order movements
 */
export function BOLNumbersRenderer(params: any) {
  if (!params.data || !params.value || params.value.length === 0) return ''

  const bolNumbers = params.value
  const hasOrderNumber = !!params.data.order_number
  const targetUrl = hasOrderNumber
    ? `/order_movements_page/report?${new URLSearchParams({
        order_number: params.data.order_number,
      })}`
    : ''

  return (
    <Horizontal gap={4} style={{ flexWrap: 'wrap' }}>
      {bolNumbers.map((bol: string, index: number) => {
        const button = (
          <GraviButton
            key={index}
            appearance='link'
            theme2
            size='small'
            buttonText={bol}
            style={{
              margin: '2px 0',
              textDecoration: 'underline',
              color: 'var(--theme-color-2)',
            }}
          />
        )

        if (hasOrderNumber) {
          return (
            <Tooltip key={index} title='View Order Movements'>
              <Link target='_blank' to={targetUrl} style={{ color: 'var(--theme-color-2)' }}>
                {button}
              </Link>
            </Tooltip>
          )
        }

        return React.cloneElement(button, { key: index })
      })}
    </Horizontal>
  )
}
